import {
  GET_ASSIGNED_REVIEWS_LIST,
  SET_SELECTED_REVIEW_TAB,
  ReviewActionType,
  AssignedReview,
  ExtendedReview,
  AppThunk,
  SET_EXTENDED_REVIEW,
} from '../types';

import ApiClient from '../../loopback/apiClient';

const setAssignedReviewList = (reviewList: AssignedReview[]): ReviewActionType => ({
  type: GET_ASSIGNED_REVIEWS_LIST,
  payload: reviewList,
});

/**
 * TODO: Currently not use anywhere
 * Purpose of this action is to refactor the /reviews by removing loopback providers
 * and putting the relavent information in redux state so that when we go in and out
 * of the perticular review, the data will be present in the redux state.
 */
export const fetchAssignedReviewlist = (
  userId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const reviewList: AssignedReview[] = await ApiClient.getAssignedReviews(userId);
  dispatch(setAssignedReviewList(reviewList));
};

export const setSelectedReviewTab = (tabId: number): ReviewActionType => ({
  type: SET_SELECTED_REVIEW_TAB,
  payload: tabId,
});

export const setExtendedReview = (extendedReview?: ExtendedReview): ReviewActionType => ({
  type: SET_EXTENDED_REVIEW,
  payload: extendedReview,
});

export const fetchExtendedReview = (
  trialId: number,
): AppThunk => async (dispatch): Promise<void> => {
  ApiClient.getExtendedReview(trialId)
    .then((val) => {
      dispatch(setExtendedReview(val[0]));
    })
    .catch((e) => null);
};
